import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useConfrimCookie from "shared/model/useConfrimCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutAccountContact = () => {

    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteConfirmCookie] = useConfrimCookie()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("PUT", "/account/contact")
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                deleteConfirmCookie()
                window.location.reload()
                break
            case 400:
                setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("계정 데이터가 존재하지 않습니다.")
                break
            case 409:
                if (fetchResult?.data?.error_code === "contact") setAlert("이미 존재하는 연락처 입니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePutAccountContact